// Buffer polyfill for browser builds. Some dependencies (e.g.
// wallet-address-validator, reached via util/validation -> config/inputs)
// reference `Buffer` at module-evaluation time. This file must be imported
// FIRST in index.js: ESM fully evaluates each import — body included — before
// evaluating the next, so as the first import this guarantees the global is set
// before anything that needs it. (Setting it inline in index.js's body runs
// only after every import has already evaluated — too late once such a module
// is in the eager graph.)
import { Buffer } from 'buffer';

if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer;
}
if (typeof window !== 'undefined' && typeof window.Buffer === 'undefined') {
  window.Buffer = Buffer;
}
